import React from 'react';
import { motion } from 'framer-motion';
import { Play, Phone } from 'lucide-react';
import Button from './Button';
import { COMPANY_INFO } from '../data/content';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://pixabay.com/get/gf87ec1ad0d24203aa06412e7a8a59508178007810cc5b9e4d0f81fc2bb7fc146310aaeeaaec45c2c2e7eb36b275b446562e1841fc5c2215c73d2e8f0bfa0822a_1280.jpg" 
          alt="Luxury Living Room" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-blue/90 to-primary-blue/40 mix-blend-multiply" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      <div className="container mx-auto px-4 z-10 pt-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white space-y-6"
          >
            <div className="flex flex-wrap gap-3 mb-4">
              <div className="inline-block px-4 py-1 bg-primary-orange/90 rounded-full text-sm font-bold tracking-wide uppercase">
                Najbolji u Novom Sadu
              </div>
              <div className="inline-block px-6 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-base font-bold tracking-wide uppercase text-white flex items-center gap-2">
                <span className="text-primary-lightBlue">★</span> Tradicija od {COMPANY_INFO.foundedYear}
              </div>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              Tip-Top <br />
              <span className="text-primary-lightBlue">najsavremenija</span> <br />
              tehnologija pranja tepiha
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-lg">
              Vracamo 100% suve, ciste i mirisne tepihe u vase domove.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => window.location.href = `tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`}
              >
                <Phone className="w-5 h-5 mr-2" />
                Pozovite Odmah
              </Button>
            </div>
          </motion.div>

          {/* Video Placeholder */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative hidden md:block"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20 group cursor-pointer">
              <img 
                src="https://pixabay.com/get/g745d6053899c1fbf7389013e65c423fb070748a45247a8d00c2259c1edacfd7586962e82b20ab6b6b294c823dadd1405e55c85b6cee1319e5546e2709e732db4_1280.jpg" 
                alt="Proces pranja" 
                className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/30 transition-colors">
                <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <div className="w-16 h-16 bg-primary-orange rounded-full flex items-center justify-center shadow-lg">
                    <Play className="w-8 h-8 text-white ml-1" fill="currentColor" />
                  </div>
                </div>
              </div>
              <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-md px-4 py-2 rounded-lg">
                <p className="text-white font-medium flex items-center gap-2">
                  <Play size={16} className="text-primary-orange" />
                  Pogledajte proces pranja
                </p>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -z-10 top-10 -right-10 w-32 h-32 bg-primary-lightBlue/30 rounded-full blur-3xl" />
            <div className="absolute -z-10 -bottom-10 -left-10 w-40 h-40 bg-primary-orange/30 rounded-full blur-3xl" />
          </motion.div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70"
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center p-2">
          <div className="w-1 h-2 bg-white rounded-full" />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
